import { render } from "./EmbodiedSentenceGeneration.vue?vue&type=template&id=4cd1450e"
import script from "./EmbodiedSentenceGeneration.vue?vue&type=script&lang=js"
export * from "./EmbodiedSentenceGeneration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__